/**
 * Excel/SheetJS の raw 数値による浮動小数点誤差を軽減するためのユーティリティ。
 * 例: 2.35 が 2.3499999999999996 として読まれるのを 2.35 に丸める。
 *
 * - 整数・NaN・Infinity はそのまま返す。
 * - 非整数の number のみ、有効桁15桁で丸める（JavaScript 倍精度の実質限界）。
 */
export function sanitizeFloatFromExcel(value: unknown): unknown {
  if (typeof value !== 'number') {
    return value
  }
  if (Number.isNaN(value) || !Number.isFinite(value)) {
    return value
  }
  if (Number.isInteger(value)) {
    return value
  }
  return Number(Number(value).toFixed(15))
}
